import { type Page } from '@ps/web-core-store';
import React from 'react';

import StarsLayoutBase from './StarsLayoutBase';
import styles from './StarsLayoutV2.scss';

const StarsLayoutV2: React.FC<Page> = (page) => (
  <StarsLayoutBase
    classes={{
      cmsNav: {
        root: styles.cmsNavRoot,
        container: styles.cmsNavContainer,
        nav: styles.cmsNav,
        navItem: styles.cmsNavItem
      },
      sideNav: styles.sideNav
    }}
    showSidenav
    {...page}
  />
);

export default StarsLayoutV2;
